import React, { useState } from 'react';
import {
  Container,
  Paper,
  Typography,
  TextField,
  Button,
  Box,
  Grid,
  Card,
  CardContent,
  Chip,
  IconButton,
} from '@mui/material';
import {
  QrCodeScanner as ScanIcon,
  CheckCircle as CheckIcon,
} from '@mui/icons-material';

export const Collection: React.FC = () => {
  const [scanInput, setScanInput] = useState('');

  const pendingSamples = [
    { id: 'SMP001', patient: 'John Doe', test: 'CBC', time: '10:30 AM' },
    { id: 'SMP002', patient: 'Jane Smith', test: 'Thyroid', time: '10:45 AM' },
    { id: 'SMP003', patient: 'Raj Kumar', test: 'Lipid Profile', time: '11:00 AM' },
  ];

  return (
    <Container maxWidth="lg" sx={{ mt: 4 }}>
      <Typography variant="h4" gutterBottom>
        Sample Collection
      </Typography>

      <Grid container spacing={3}>
        <Grid size={{ xs: 12, sm: 6 }}>
          <Paper sx={{ p: 3 }}>
            <Typography variant="h6" gutterBottom>
              Scan Sample QR Code
            </Typography>
            <Box display="flex" gap={2}>
              <TextField
                fullWidth
                placeholder="Scan or enter Sample ID"
                value={scanInput}
                onChange={(e) => setScanInput(e.target.value)}
              />
              <Button variant="contained" startIcon={<ScanIcon />}>
                Scan
              </Button>
            </Box>
          </Paper>
        </Grid>

        <Grid  size={{ xs: 12, md: 6 }}>
          <Paper sx={{ p: 3 }}>
            <Typography variant="h6" gutterBottom>
              Pending Collections
            </Typography>
            {pendingSamples.map((sample) => (
              <Card key={sample.id} sx={{ mb: 2 }}>
                <CardContent>
                  <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Box>
                      <Typography variant="subtitle1">{sample.patient}</Typography>
                      <Typography variant="body2" color="textSecondary">
                        {sample.test} • {sample.time}
                      </Typography>
                      <Chip label={sample.id} size="small" sx={{ mt: 1 }} />
                    </Box>
                    <IconButton color="success">
                      <CheckIcon />
                    </IconButton>
                  </Box>
                </CardContent>
              </Card>
            ))}
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
};